import { DialogContainer } from '@/modules/MuiDialog';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar, useScrollTrigger } from '@mui/material';
import { cloneElement, ReactComponentElement, useCallback, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLoaderData, useNavigate, useOutlet } from 'react-router-dom';

type MobileHeaderProps = {
    title?: string;
    rootPath?: string;
};
export const MobileHeader = ({ title, rootPath = '/' }: MobileHeaderProps) => {
    const navigate = useNavigate();

    const trigger = useScrollTrigger({
        target: window,
        threshold: 25,
    });

    const handleHistoryBack = useCallback(() => {
        const { state } = history;
        const { referrer } = document;

        if (state.idx > 0) {
            console.log('history', { history, state, referrer });
            if (state.usr?._isRedirect) {
                navigate(-2);
            } else {
                navigate(-1);
            }
        } else {
            navigate(rootPath);
        }
    }, [navigate]);

    return (
        <>
            <DialogContainer />
            <AppBar
                position={'sticky'}
                elevation={0}
                color={'transparent'}
                sx={{
                    boxShadow: trigger ? '0px 3px 5px rgba(0, 0, 0, 0.15)' : undefined,
                }}
            >
                <Toolbar
                    variant={'dense'}
                    disableGutters={true}
                    sx={{
                        // position: 'sticky',
                        // top: 0,
                        // justifyContent: 'space-between',
                        px: 1,
                        backgroundColor: 'var(--v-palette-background-paper)',
                        backgroundImage: 'var(--v-overlays-24)',
                    }}
                >
                    <IconButton
                        onClick={() => {
                            handleHistoryBack();
                        }}
                    >
                        <BackIcon />
                    </IconButton>
                    {!!title && <h1 className={'grow text-h6 ml-2'}>{!!title ? title : ''}</h1>}
                </Toolbar>
            </AppBar>
        </>
    );
};

type MobilePagesProps = {
    header?: ReactComponentElement<any> | undefined;
    title?: string;
    rootPath?: string;
};

const MobilePages = ({ header = <MobileHeader />, rootPath }: MobilePagesProps) => {
    const { pageTitle, hideHeader }: any = useLoaderData() || {};
    const [title, setTitle] = useState<string | null>(null);
    const outlet = useOutlet();

    return (
        <>
            {(!!title || !!pageTitle) && <Helmet title={title || pageTitle} />}
            <Box
                sx={{
                    margin: '0 auto',
                    width: '100%',
                    flex: 1,
                    maxWidth: 600,
                    backgroundColor: 'var(--v-palette-background-paper)',
                    backgroundImage: 'var(--v-overlays-24)',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 'var(--v-shadows-3)',
                }}
            >
                {!!header && !hideHeader
                    ? cloneElement(header, {
                          title: title || pageTitle || undefined,
                          rootPath,
                      })
                    : ''}

                <Box
                    sx={{
                        flexGrow: 1,
                        px: 2,
                        py: 3,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Outlet context={[title, setTitle]} />
                </Box>
            </Box>
        </>
    );
};

export default MobilePages;
